import { IconButton, Tooltip } from "@chakra-ui/react";
import { Icon } from "@components/ui-kit/Icon";
import { observer } from "mobx-react-lite";

type StarButtonProps = {
  label: (starred: boolean) => string;
  isStarred: boolean;
  isLoading?: boolean;
  onClick?: (starred: boolean) => void;
};

export const StarButton = observer(function StarredColumn({
  isStarred,
  isLoading,
  onClick,
  label,
}: StarButtonProps) {
  return (
    <Tooltip label={label(isStarred)} placement="top">
      <IconButton
        aria-label={label(isStarred)}
        icon={
          <Icon
            name="star-01"
            variant={isStarred ? "solid" : "line"}
            color={isStarred ? "yellow.500" : "gray.400"}
          />
        }
        isLoading={isLoading}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick?.(!isStarred);
        }}
        size="sm"
        variant="ghost"
      />
    </Tooltip>
  );
});
